import { Segmented, message, Skeleton, Button } from "antd";
import { useEffect, useMemo, useState, useContext, useRef } from "react"
import API from '@api/api'
import Utils from '@utils/utils'
import styles from './index.module.scss'
import markIcon from '@assets/images/svgIcon/markIcon.svg'
import freeIcon from '@assets/images/svgIcon/freeIcon.svg'
import { MinusCircleFilled, PlusCircleFilled } from '@ant-design/icons'
import eventBus from "@utils/eventBus"
import { AppContext } from '@utils/AppContext';
import { SELECT_ORG_TYPE } from '@utils/CONST';



const options = [
    { label: '个人月卡', value: 0 },
    { label: '团队年卡', value: 1 }
]

const MemberPackage = (props) => {
    const { globalUser, globalOrgInfo, setPayOrderInfo, payOrderInfo } = useContext(AppContext);
    const [type, setType] = useState(globalOrgInfo?.current?.id ? 1 : 0)
    const [diyPower, setDiyPower] = useState('')
    const [diyMember, setDiyMember] = useState('')
    const [plansList, setPlansList] = useState([{
        level: "basic",
        currentLevel: 1,
        enTitle: 'PSAI',
        zhTitle: '捕光逐影',
        price: '19.9',
        discountPrice: '48',
        convert: '1,000虹豆 （1虹豆≈0.048）',
        imgCount: 100,
        singlePrice: 0.48,
        powerList: ['每日登录赠送积分', '高清下载']
    }, {
        level: "pro",
        currentLevel: 2,
        enTitle: 'PSAI',
        zhTitle: '捕光逐影',
        price: '19.9',
        convert: '5,000虹豆 （1虹豆≈0.037）',
        imgCount: 500,
        singlePrice: 0.48,
        powerList: ['每日登录赠送积分', '高清下载', '支持2台设备同时在线']
    }, {
        level: "max",
        currentLevel: 3,
        enTitle: 'PSAI',
        zhTitle: '捕光逐影',
        price: '19.9',
        convert: '20,000虹豆 （1虹豆≈0.024）',
        imgCount: 2000,
        singlePrice: 0.48,
        selected: true,
        powerList: ['每日登录赠送积分', '高清下载', '支持4台设备同时在线', '专属1v1客服支持']
    }, {
        level: "ultra",
        currentLevel: 4,
        enTitle: 'PSAI',
        zhTitle: '捕光逐影',
        price: '19.9',
        convert: '40,000虹豆 （1虹豆≈0.022）',
        imgCount: 4000,
        singlePrice: 0.48,
        powerList: ['每日登录赠送积分', '高清下载', '支持6台设备同时在线', '专属1v1客服支持']
    }])

    const [yearPlansList, setYearPlansList] = useState([{
        level: "teamPro",
        currentLevel: 5,
        title: 'PSAI 团队版 Pro',
        price: '1579',
        beanCount: '60,000',
        accountCount: '2',
        imgCount: 6000,
        singlePrice: 0.26,
        convert: '1虹豆≈0.026',
        powerList: ['虹豆团队共享', '主子账号管理', '超划算虹豆加油包', '专属1v1客服支持']
    }, {
        level: "teamMax",
        currentLevel: 6,
        config: true,
        title: 'PSAI 团队版 Max',
        price: '1579',
        beanCount: '60,000',
        accountCount: '2',
        imgCount: 6000,
        singlePrice: 0.26,
        customize: true,
        convert: '1虹豆≈0.017',
        powerList: ['虹豆团队共享', '主子账号管理', '超划算虹豆加油包', '专属1v1客服支持']
    }])
    const memberLevel = useMemo(() => {
        return (globalUser?.membership?.level && globalUser?.membership?.level != -100)  ? 
        globalUser?.membership?.level : 0
    }, [globalUser])



    const onPayedClick = (id, currentLevel) => {
        const status = Utils.checkLoginStatus(() => onPayedClickFun(id, currentLevel))
        if (!status) return
        onPayedClickFun(id, currentLevel)
    }
    const onPayedClickFun = (id, currentLevel) => {
        if (currentLevel < memberLevel) {
            message.warning('您当前会员等级已高于该等级！')
            return
        }
        if (currentLevel == 6) {
            const teamMax = yearPlansList.find(item => item.config);
            if (!teamMax) return;
            setPayOrderInfo({
                ...payOrderInfo,
                diyPower: teamMax.beanCount,
                diyMember: teamMax.accountCount,
                skuId: id,
                orgId: globalOrgInfo?.current.id,
            })
        } else {
            setPayOrderInfo({
                ...payOrderInfo,
                skuId: id,
                orgId: globalOrgInfo?.current.id,
            })
        }

        setTimeout(() => {
            if (globalOrgInfo?.isPersonal && (currentLevel == 5 || currentLevel == 6) && globalOrgInfo?.orgList.length > 1) {
                // 个人用户购买团队套餐且有多个团队时，打开选择团队弹窗
                eventBus.emit('OPEN_SELECT_TEAM', { type: SELECT_ORG_TYPE.BUYORG })
            } else {
                // 其他情况下直接发起支付
                eventBus.emit('pc_pay')
            }
        }, 30)
    }


    const getListPlan = () => {
        API.getListPlan({}).then((res) => {
            if (res.code == 0) {
                const updatedPlansList = [...plansList];
                const updatedYearPlansList = [...yearPlansList];

                res.data.forEach(item => {
                    const planIndex = updatedPlansList.findIndex(plan => plan.level === item.level);
                    const yearPlanIndex = updatedYearPlansList.findIndex(plan => plan.level === item.level);

                    if (planIndex !== -1) {
                        updatedPlansList[planIndex].zhTitle = item.description;
                        updatedPlansList[planIndex].id = item.id;
                        updatedPlansList[planIndex].enTitle = item.name;
                        updatedPlansList[planIndex].price = globalUser?.payedUser === 0  ? item.firstBuyPrice : item.price;
                        updatedPlansList[planIndex].imgCount = item.powerAmount / 10;
                        updatedPlansList[planIndex].singlePrice = (globalUser?.payedUser === 0 && Math.ceil(item.uPrice) / 100 == 0.48) ? 0.199 : Math.ceil(item.uPrice) / 100;
                        updatedPlansList[planIndex].convert = `${item.powerAmount}虹豆 （1虹豆≈${(globalUser?.payedUser === 0 && Math.ceil(item.uPrice) / 100 == 0.48) ? 0.199 : Math.ceil(item.uPrice) / 100}）`

                    }
                    if (yearPlanIndex !== -1) {
                        updatedYearPlansList[yearPlanIndex].title = item.name;
                        updatedYearPlansList[yearPlanIndex].id = item.id;
                        updatedYearPlansList[yearPlanIndex].price = Math.ceil(item.price);
                        updatedYearPlansList[yearPlanIndex].imgCount = item.powerAmount / 10;
                        updatedYearPlansList[yearPlanIndex].singlePrice = Math.ceil(item.uPrice) / 100;
                        updatedYearPlansList[yearPlanIndex].accountCount = item.supportMembers;
                        updatedYearPlansList[yearPlanIndex].initAccountCount = item.supportMembers;
                        updatedYearPlansList[yearPlanIndex].beanCount = item.powerAmount;
                        updatedYearPlansList[yearPlanIndex].initBeanCount = item.powerAmount;

                    }
                });

                setPlansList(updatedPlansList);
                setYearPlansList(updatedYearPlansList);
            }
        })
    }

    useEffect(() => {
        getListPlan()
    }, [])

    useEffect(() => {
        const teamMax = yearPlansList.find(item => item.config);
        if (!teamMax) return;
        console.log('beanCount 或 accountCount 变化了', {
            beanCount: teamMax.beanCount,
            accountCount: teamMax.accountCount
        });
        setPayOrderInfo({
            ...payOrderInfo,
            diyPower: teamMax.beanCount,
            diyMember: teamMax.accountCount,
        })
    }, [yearPlansList.find(item => item.config)?.beanCount, yearPlansList.find(item => item.config)?.accountCount]);


    // 点击增减函数
    const handleAdjust = (index, field, type) => {
        setYearPlansList(prev => {
            const newList = [...prev];
            const item = { ...newList[index] };

            item.beanCount = Number(item.beanCount);
            item.accountCount = Number(item.accountCount);
            item.price = Number(item.price);

            if (field === 'beanCount') {
                if (type === 'add') {
                    item.beanCount += 10000;
                    item.price += 170;
                } else if (type === 'minus' && item.beanCount > (item.initBeanCount ?? item.beanCount)) {
                    item.beanCount -= 10000;
                    item.price -= 170;
                }
            }

            if (field === 'accountCount') {
                if (type === 'add') {
                    item.accountCount += 1;
                    item.price += 288;
                } else if (type === 'minus' && item.accountCount > 6) { //最低6个席位
                    item.accountCount -= 1;
                    item.price -= 288;
                }
            }

            newList[index] = item;
            return newList;
        });
    };

    const validityDay = useMemo(() => {
        const today = new Date();
        const future = new Date(today);
        if (type === 0) {
            future.setDate(today.getDate() + 30);
        } else if (type === 1) {
            future.setDate(today.getDate() + 365);
        }
        // 格式化日期为字符串 YYYY年MM月DD日
        const year = future.getFullYear();
        const month = String(future.getMonth() + 1).padStart(2, '0');
        const day = String(future.getDate()).padStart(2, '0');
        return `${year}年${month}月${day}日`;
    }, [type])

    return (
        <div className={styles.MemberPackage}>
            {
                !globalOrgInfo?.current?.id && <Segmented
                    className={styles.Segmented}
                    value={type}
                    options={options}
                    onChange={(value) => setType(value)} />
            }

            <div className={styles.planList}>
                {
                    type === 0 ? plansList.map((item, index) => (
                        <div
                            onClick={() => onPayedClick(item.id, item.currentLevel)}
                            className={`${styles.planItem} ${item.selected ? styles.planItemSelected : ''}`}
                            key={index}>
                            <p className={styles.zhTitle}>{item.enTitle}</p>
                            <p className={styles.enTitle}>{item.zhTitle}</p>
                            <p className={styles.price}>
                                <span>¥<span>{item.price}</span> /月</span>
                                {(item.discountPrice && globalUser?.payedUser === 0 ) && <span>¥{item.discountPrice}/月</span>}
                            </p>
                            <p className={styles.convert}>{item.convert}</p>
                            <p className={styles.imgCount}>最多可生成 <span>{item.imgCount}张</span> 图片</p>
                            <p className={styles.singlePrice}>单张图片价格低至 <span>{item.singlePrice}元</span></p>
                            <div
                                className={`${styles.buyBtn} ${item.selected ? styles.selected : ''}`}>立即购买</div>
                            <div className={styles.powerList}>
                                {item.powerList.map((power, index) => (
                                    <p key={index}><img src={markIcon} alt="" />{power}</p>
                                ))}
                            </div>
                        </div>
                    )) : <>
                        {
                            yearPlansList.map((item, index) => (
                                <div
                                    className={`${styles.planItemYear} ${item.customize ? styles.planItemYearSelected : ''}`}
                                    key={index}>
                                    <p className={styles.title}>{item.title}</p>
                                    <p className={styles.price}>¥<span>{item.price}</span> /年</p>
                                    <p className={styles.beanCount}>
                                        {item.config && <MinusCircleFilled
                                            className={styles.minusIcon}
                                            style={{ color: item?.beanCount == 240000 ? '#EEEEEE' : '#52A8FF ' }}
                                            onMouseDown={(e) => e.preventDefault()}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleAdjust(index, 'beanCount', 'minus');
                                            }} />}
                                        <span className={`${styles.beanNum} ${!item.config? styles.beanNumPro : ''}`}>{item.beanCount}</span>
                                        {item.config && <PlusCircleFilled
                                            className={styles.plusIcon}
                                            onMouseDown={(e) => e.preventDefault()}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleAdjust(index, 'beanCount', 'add');
                                            }} />}
                                        虹豆
                                        <span className={styles.beanDesc}>{item.convert}</span>
                                    </p>

                                    <p className={styles.beanCount}>
                                        {item.config && <MinusCircleFilled
                                            style={{ color: item.accountCount == 6 ? '#EEEEEE' : '#52A8FF ' }}
                                            className={styles.minusIcon}
                                            onMouseDown={(e) => e.preventDefault()}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleAdjust(index, 'accountCount', 'minus');
                                            }} />}
                                        <span className={`${styles.beanNum} ${!item.config? styles.beanNumPro : ''}`}>{item.accountCount}</span>
                                        {item.config && <PlusCircleFilled
                                            className={styles.plusIcon}
                                            onMouseDown={(e) => e.preventDefault()}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleAdjust(index, 'accountCount', 'add');
                                            }} />}
                                        个账号
                                    </p>
                                    <div className={styles.buyBtn} onClick={() => onPayedClick(item.id, item.currentLevel)}>立即购买</div>
                                    <p className={styles.imgCount}>最多可生成 <span>{item.imgCount}张</span> 图片</p>
                                    <p className={styles.singlePrice}>单张图片价格低至 <span>{item.singlePrice}元</span></p>
                                    <div className={styles.powerList}>
                                        {item.powerList.map((power, index) => (
                                            <p key={index}><img src={markIcon} alt="" />{power}</p>
                                        ))}
                                    </div>
                                </div>
                            ))
                        }
                        <div className={styles.planItemYearLast}>
                            <p className={styles.title1}>企业解决方案</p>
                            <img src={freeIcon} alt="" />
                            <p className={styles.title2}>一站式交付</p>
                            <p className={styles.title3}>品牌资产定制</p>
                            <p className={styles.desc} style={{ marginTop: 24 }}>批量制作·模特定制·套餐定制·按需选择/调整</p>
                            <p className={styles.desc}>VIP专属团队服务</p>
                            <img className={styles.qrcodeSales} src={Utils.qrcodeSales} alt="扫码联系我们" />
                            <p className={styles.desc}>添加PSAI专员微信</p>
                            <p className={styles.desc}>为您提供最佳的策略和方案</p>
                        </div>
                    </>
                }
            </div>
            <p className={styles.planValidity}>会员方案有效期为{
                type === 0 ? '30天' : '365天'}，现在购买有效期至{validityDay}</p>
        </div>
    )
}

export default MemberPackage